import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useLocation, useNavigate } from "@tanstack/react-router";

import { careplanQueryOptions } from "@/domains/careplan/factories";
import { cartDiscountCodesUpdateMutation } from "@/domains/careplan/models/graphql";
import { storefrontApi } from "@/modules/network";
import type {
  CartDiscountCodesUpdateMutation,
  CartDiscountCodesUpdateMutationVariables,
} from "@/types";

export const useUpdateCareplanCartDiscount = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  return useMutation({
    mutationFn: updateCareplanCartDiscount,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: careplanQueryOptions.cart.queryKey,
      });

      const { discount, ...searchWithoutDiscount } = search;

      if (discount) {
        navigate({
          to: pathname,
          search: searchWithoutDiscount,
          replace: true,
          resetScroll: false,
        });
      }
    },
  });
};

const updateCareplanCartDiscount = async (variables: CartDiscountCodesUpdateMutationVariables) => {
  const response = await storefrontApi.request<CartDiscountCodesUpdateMutation>(
    cartDiscountCodesUpdateMutation,
    {
      variables,
    },
  );

  return response.data;
};
